
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogRT(): TemplateResult<dialogRTRootProps> {
    return _createElement('div', {
        'className': 'dialog-container',
        'data-step': '0'
    }, _createElement('div', { 'className': 'cm_vehicle-tiles-dialog-container' }, _createElement('div', { 'className': 'cm_vehicle-tiles-dialog-content-container' }, _createElement('div', { 'className': 'cm_vehicle-tiles-dialog-content step-ymm' }, [this.DialogVehicleWidget_tiles(function () {
            function repeatTileContainers1(tileContainers, tileContainersIndex) {
                return [tileContainers(function () {
                        function repeatTiles1(tiles, tilesIndex) {
                            return [tiles(function () {
                                    return _createElement('a', {
                                        'className': 'cm_vehicle-tiles__tile',
                                        'onClick': () => {
                                            this.selectValue();
                                            window.Convermax.changeStep('next');
                                        }
                                    }, this.value);
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'cm_vehicle-tiles__tiles-container ' + this.field.toLowerCase() }, _createElement.apply(this, [
                            'div',
                            { 'className': 'cmRepeater_tiles' },
                            _map(this.tiles, repeatTiles1.bind(this))
                        ]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_DialogVehicleWidget_tiles' }, _createElement('div', { 'className': 'cm_vehicle-tiles-dialog-header' }, _createElement('div', { 'className': 'cm_vehicle-tiles-dialog-stepper' }, _createElement('div', { 'className': 'cm_vehicle-tiles-dialog-stepper-content' }, [this.chips(function () {
                    function repeatChipsRepeater1(chipsRepeater, chipsRepeaterIndex) {
                        return [chipsRepeater(function () {
                                return _createElement('button', {
                                    'className': 'cm_vehicle-tiles-dialog-stepper-prev',
                                    'onClick': () => {
                                        this.discardValue();
                                        window.Convermax.changeStep('prev');
                                    }
                                }, '\n                      \u2B05 Back\n                    ');
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_chips' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cmRepeater_chipsRepeater' },
                        _map(this.chipsRepeater, repeatChipsRepeater1.bind(this))
                    ]));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])), _createElement('button', {
                'className': 'cm_vehicle-tiles-dialog-close',
                'data-cm-role': 'close'
            }, _createElement('div', {}, _createElement('svg', {
                'width': '24',
                'height': '24',
                'viewBox': '0 0 24 24',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg'
            }, _createElement('mask', {
                'id': 'mask0_1403_1055',
                'style': { maskType: 'alpha' },
                'maskUnits': 'userSpaceOnUse',
                'x': '0',
                'y': '0',
                'width': '25',
                'height': '25'
            }, _createElement('rect', {
                'x': '0.157227',
                'y': '0.117432',
                'width': '24',
                'height': '24',
                'fill': '#D9D9D9'
            })), _createElement('g', { 'mask': 'url(#mask0_1403_1055)' }, _createElement('path', {
                'd': 'M6.55742 19.9174L4.35742 17.7174L9.95742 12.1174L4.35742 6.51743L6.55742 4.31743L12.1574 9.91743L17.7574 4.31743L19.9574 6.51743L14.3574 12.1174L19.9574 17.7174L17.7574 19.9174L12.1574 14.3174L6.55742 19.9174Z',
                'fill': '#231F20'
            })))))), _createElement('div', { 'className': 'cm_vehicle-tiles' }, _createElement('div', { 'className': 'cm_vehicle-tiles__chips' }, _createElement('div', { 'className': 'cm_vehicle-tiles__chips-title cm_vehicle-tiles__title' }, '\n                Add\n                ', this.selectedFields.length === 0 ? _createElement('span', { 'key': '2024' }, 'Vehicle') : null, [this.chips(function () {
                    function repeatChipsRepeater1(chipsRepeater, chipsRepeaterIndex) {
                        return [chipsRepeater(function () {
                                return _createElement('span', {}, ' ', this.value, ' ');
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_chips' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_vehicle-tiles__chips-repeater cmRepeater_chipsRepeater' },
                        _map(this.chipsRepeater, repeatChipsRepeater1.bind(this))
                    ]));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])), [this.filterInput(function () {
                    return _createElement('div', {
                        'placeholder': 'Type or choose your vehicle make',
                        'className': 'cm_filterInput'
                    });
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-tiles__tiles-repeater cmRepeater_tileContainers' },
                _map(this.tileContainers, repeatTileContainers1.bind(this))
            ])));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]))));
}
        export const componentNames = ["cm:chips","cm:chips","cm:filterInput","cm:DialogVehicleWidget_tiles"]